module.exports = __webpack_public_path__ + "static/web-2-890762eabd2f93faa06a4a6c763fcc43.png";